<template>
    <v-form ref="passwordCodeSentForm" v-model="valid" lazy-validation>
        <div class="password-code-sent__success">
            <div class="password-code-sent__success-message">{{loginConstants.PASSWORD_CODE_SUCCESS_1}}</div>
            <div class="password-code-sent__success-destination">{{selectedPasswordDelivery.destination}}</div>
        </div>
        <v-menu origin="top"
                attach
                bottom
                nudge-bottom="30"
                class="password-code-sent__help-menu"
                transition="scale-transition">
            <v-btn id="did_not_receive_email_link"
                   data-qe-id="did_not_receive_email_link"
                   slot="activator"
                   :disabled="isSubmitting"
                   color="ypo_cta"
                   class="password-code-sent__did-not-receive"
                   flat>
                {{loginConstants.DID_NOT_RECEIVE_EMAIL_TEXT}}
            </v-btn>
            <v-layout column class="password-code-sent__help-text">
                <v-flex v-html="loginConstants.PASSWORD_RESET_FURTHER_HELP"></v-flex>
            </v-layout>
        </v-menu>
        <Login-error class="password-code-sent__error"></Login-error>
        <v-card-actions>
            <v-layout row wrap>
                <v-btn id="continue_to_code_entry_btn"
                       data-qe-id="continue_to_code_entry_btn"
                       color="ypo_blue"
                       class="white--text"
                       @click="continueMe()" 
                       large
                       block>
                    {{loginConstants.ENTER_CODE}}
                </v-btn>
            </v-layout>
        </v-card-actions>
    </v-form>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { storeAction } from "../../../store/storeActions.constant";
    import { loginConstants } from '../login.constants';
    import LoginError from '../LoginError';

    export default {
        name: 'PasswordCodeSent',
        components: { LoginError },
        data: () => ({
            loginConstants,
            valid: true,
            componentNames: loginConstants.componentNames,
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
        },
        methods: {
            ...mapActions({
                submitSelectTypePasswordDelivery: `auth/${storeAction.submitSelectTypePasswordDelivery}`,
            }),
            continueMe() {
                this.changeCardState(this.componentNames.enterPasswordResetCode.component);
            },
        },
        computed: {
            ...mapGetters({
                selectedPasswordDelivery: `auth/${storeGetters.getSelectTypePasswordDelivery}`,
            }),
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .password-code-sent {
        &__title {
            padding: 5px 10px 20px 5px;
            font-size: 16px;
            color: $black;
            opacity: 0.9;
        }

        &__success {
            padding: 5px 10px 20px 5px;
            font-size: 16px;
            
            &-destination {
                color: $ypo-gold;
                word-break: break-all;
            }
        }

        &__error {
            padding: 0 5px 10px;
        }

        &__resend {
            color: $ypo-blue-secondary;
        }

        &__did-not-receive {
            text-transform: none;
            padding: 0 5px 0;
            margin: 0;
        }

        &__help-menu {

            .v-menu__content {
                right: 40px;

                @include breakpoint(sm) {
                    right: 15px;
                }
            }
        }

        &__help-text {
            background-color: $ypo-blue;
            color: $white;
            font-size: 14px;
            padding: 10px 5px 0;
        }

    }
    .v-btn__content{
        @include breakpoint(xs) {
            font-size: 12px !important;
        }
    }

    .v-card__actions {
        padding: 5px 0 5px 5px !important;
        @include breakpoint(xs) {
            padding: 0 !important;
        }
    }

</style>
